import React, { memo, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Button,
} from "reactstrap";
import * as Ionicons from "react-icons/io";

const EditDropDown = memo(
  ({
    editState,
    setEditState,
    targetItem,
    updatedOrgProfile,
    value,
    mutationVariables,
    mutatinValiablesKey,
  }) => {
    const SyncIcon = Ionicons["IoIosSync"];
    const CloseIcon = Ionicons["IoMdClose"];

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownToggle = () => {
      setDropdownOpen(!dropdownOpen);
    };
    const legal_entity = [
      ("1", "NPO"),
      ("2", "認定NPO"),
      // 2022.06.26追加
      ("12", "特例認定NPO"),
      ("3", "一般財団"),
      ("4", "公益財団"),
      ("5", "一般社団"),
      ("6", "公益社団"),
      ("7", "学校法人"),
      ("8", "なし（任意団体）"),
      ("9", "株式会社"),
      ("10", "有限会社"),
      ("11", "合同会社"),
    ];
    const [targetKey, setTargetKey] = useState(value);

    //編集モードON/OFF
    const chengeEditStatus = () => {
      let newEditStatus = { ...editState };
      newEditStatus[targetItem] = !editState[targetItem];
      setEditState(newEditStatus);
    };

    const updateMutation = () => {
      mutationVariables[mutatinValiablesKey] = legal_entity[targetKey];
      updatedOrgProfile(mutationVariables);
      chengeEditStatus();
    };

    return (
      <div className="flex-ai-center">
        <Dropdown isOpen={dropdownOpen} toggle={dropdownToggle}>
          <DropdownToggle
            caret
            style={{
              background: "#fff",
              color: "#495057",
              borderColor: "#ced4da",
            }}
          >
            {legal_entity[targetKey]}
          </DropdownToggle>
          <DropdownMenu>
            {legal_entity.map((arr, index) => (
              <DropdownItem
                key={index}
                name={index}
                value={`${index}`}
                style={{ height: 30 }}
                onClick={(e) => {
                  setTargetKey(index);
                }}
              >
                {arr}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
        <Button
          className="ema__btn__update"
          onClick={() => {
            updateMutation();
          }}
        >
          <SyncIcon fontSize="18px" style={{ marginRight: 4 }} /> 更新
        </Button>
        <Button onClick={chengeEditStatus} style={{ padding: "0.3rem 8px" }}>
          <CloseIcon fontSize="16px" className="pointer" />
        </Button>
      </div>
    );
  }
);
export default EditDropDown;
